function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import { format, isValid, parseISO } from "date-fns";
import { toISODate } from "../utils/common";
import moment from "moment"; /*
                             This will take an invalid date eg feb 29th in a non leap year and declare it invalid.
                             where as dateFns isValid will declare this a valid date, as dateFns simply relies upon javascript's new Date().
                             new Date('2001-02-29'); , will return a new date of march..... therefore valid.
                             */
export var isValidDate = function isValidDate(date) {
  var _date$split = date.split("-"),
    _date$split2 = _slicedToArray(_date$split, 3),
    yearStr = _date$split2[0],
    monthStr = _date$split2[1],
    dayStr = _date$split2[2];
  if (yearStr && yearStr.length === 4 && monthStr && monthStr.length >= 1 && monthStr.length <= 2 && dayStr && dayStr.length >= 1 && dayStr.length <= 2) {
    var d = parseISO(date);
    var year = Number(yearStr);
    var month = Number(monthStr);
    var day = Number(dayStr);
    --month; // need to reduce month value by 1 to accommodate new Date formats the month
    if (d.getFullYear() === year && d.getMonth() === month && d.getDate() === day) {
      return true;
    }
    return false;
  }
  return false;
};
var validDate = function validDate(value) {
  if (!value || !isValidDate(value)) {
    return "Please enter a valid date.";
  }
  var isoDateString = toISODate(value);
  var isoDate = parseISO(isoDateString);
  var currentDate = moment(format(new Date(), "yyyy-MM-dd"));
  var errors;
  if (!isValid(isoDate)) {
    errors = "Please enter a valid date.";
  }
  return errors;
};
export default validDate;